import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';

function StFrancisShangrila() {

    return (
        <>
            <Header />
            <section id='st-francis-shangrila'>
                <div className='container'>
                    <div className='row my-5'>
                        <h4 className='text-primary text-start mb-0'>Furnished 1 Bedroom in St. Francis Shangri-La, Mandaluyong</h4>
                        <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> Shaw Boulevard cor St. Francis, Ortigas Center, Mandaluyong</small></p>
                        <div className='row mb-3'>
                            <div className='col-lg-5'>
                                <div className='text-start'>
                                    <p className='mb-0'><b>About St Francis Shangrila</b></p>
                                    <p>
                                        <small>
                                            A luxury residential development of the Shang Grand Tower Corporation, a member of the Kuok Group,
                                            renowned for their quality properties in Australia, China, Hong Kong, Malaysia, The Philippines and
                                            Singapore. In Manila, The Group’s The Shang Grand Tower, The Enterprise Center, and Shangri-la brands
                                            are landmarks of quality.
                                            <br />
                                            <br />
                                            Now, The St. Francis offers the opportunity to buy into Manila’s most exciting development with all
                                            the hallmarks of a premium Kuok Group Residence.
                                        </small>
                                    </p>

                                    <p className='mb-0'><b>Where are we located?</b></p>
                                    <p>
                                        <small>
                                            The St. Francis Shangri-La Place is in a beautifully appointed neighborhood. The condominium is directly
                                            linked by comfortable walkways to the EDSA Shangri-la Hotel and has covered access to Shangri-la Plaza Mall.
                                            The MRT is also within easy reach via the mall.
                                            <br />
                                            <br />
                                            The District, known as the Ortigas Business Center, is the home of the San Miguel Corporation, the Asian Development Bank,
                                            Meralco, the Philippine Stock Exchange, the New Medical City Hospital and the Wack Wack Golf and Country Club.
                                        </small>
                                    </p>
                                </div>
                            </div>
                            <div className='col-lg-7'>
                                <div id="StFrancisShangrilaProject" className="carousel slide" data-bs-ride="carousel">
                                    <div className="carousel-indicators">
                                        <button type="button" data-bs-target="#StFrancisShangrilaProject" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#StFrancisShangrilaProject" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                        <button type="button" data-bs-target="#StFrancisShangrilaProject" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                        <button type="button" data-bs-target="#StFrancisShangrilaProject" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                    </div>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis7.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis7.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis77.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis77.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis7777.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis7777.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis77777.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis77777.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="carousel-control-prev" type="button" data-bs-target="#StFrancisShangrilaProject" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target="#StFrancisShangrilaProject" data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </div>
                                <p className='d-xxl-none d-xl-none d-xxl-block d-lg-none d-xl-block'> <small><i>Tap to Enlarge</i></small></p>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className='col-lg-8'>
                                <div id="StFrancisShangrilaUnit" className="carousel slide" data-bs-ride="carousel">
                                    <div className="carousel-indicators">
                                        <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                        <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                        <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                        <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                        <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                        <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="6" aria-label="Slide 7"></button>
                                        <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="7" aria-label="Slide 8"></button>
                                    </div>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis12.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis12.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Bed Room</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis10.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis10.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Dining and Kitchen</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis9.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis9.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Lobby Area</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis8.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis8.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Lounge Area</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis77.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis77.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Grand View</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis6.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis6.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Sauna</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis5.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis5.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Gym</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="carousel-control-prev" type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </div>
                                <p className='d-xxl-none d-xl-none d-xxl-block d-lg-none d-xl-block'> <small><i>Tap to Enlarge</i></small></p>
                            </div>
                            <div className='col-lg-4'>
                                <div className='text-start text-small'>
                                    <p className=''>
                                        <b>The St Frances Shangri-La</b>
                                        <br />
                                        <small>Unit: TBP</small>
                                    </p>

                                    <b>Description:</b>
                                    <ul>
                                        <li><small>1 Bedroom</small></li>
                                        <li><small>Fully-furnished</small></li>
                                        <li><small>57 sq.m. (613.54 sq.ft)</small></li>
                                        <li><small>Panoramic views</small></li>
                                        <li><small>near Shopping Malls</small></li>
                                    </ul>
                                    <b>Unit Features:</b>
                                    <ul>
                                        <li><small>luxerous Wooden BedFrame</small></li>
                                        <li><small>elegant Wooden Cabinets</small></li>
                                        <li><small>ostentatious Dining Area</small></li>
                                        <li><small>magnificent Lobby</small></li>
                                        <li><small>view of Ortigas Center</small></li>
                                    </ul>
                                    <p>
                                        <small>
                                            Available for viewing
                                            <br />
                                            <b>PhP80,000 per month</b>
                                            <br />
                                            Minimum 12 months lease
                                        </small>
                                    </p>
                                    <div className='d-flex flex-row'>
                                        <a className='btn btn-success' href='/contact-us'>Contact us for Viewing</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <h4 className='text-start text-primary'>Amenities and Location</h4>
                            <div className='row mb-3'>
                                <div className='col-lg-6'>
                                    <a href="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis_Amenities.jpg">
                                        <img className="img-fluid pt-4"
                                            src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis_Amenities.jpg"
                                            alt="...">
                                        </img>
                                    </a>
                                    <p className='d-xxl-none d-xl-none d-xxl-block d-lg-none d-xl-block'> <small><i>Tap to Enlarge</i></small></p>
                                </div>
                                <div className='col-lg-6'>
                                    <iframe width="100%" height="400rem"
                                        title="XQVNmgdYRUQ"
                                        src="https://www.youtube.com/embed/MqbnbnCEoS8?autoplay=1&controls=1&loop=0&mute=0&rel=0&start=0">
                                    </iframe>
                                    <p className=''><small>Credit to the Owner</small></p>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-5 text-start'>
                                    <p className='mb-0'><b>About Kuok Group Residence</b></p>
                                    <p>
                                        <small>
                                            Kuok Brothers started in 1949 in Johor Bahru, Malaysia as a small family business trading rice, sugar 
                                            and wheat flour. As the company expanded within the region, Kuok Singapore was founded in 1953, 
                                            and the Hong Kong office was established in 1974 as Kerry Holdings. The Kerry Group now oversees 
                                            the company’s operations in Hong Kong and Mainland China.
                                            <br/>
                                            <br/>
                                            Over 70 years, the Kuok Group has grown to become one of Asia's most dynamic multinational conglomerates,
                                            with operations spanning six continents in sectors ranging from logistics and maritime to properties and
                                            hospitality. Guided by the values of Robert Kuok, the Group’s founder, our corporate culture is built on
                                            perseverance, loyalty, and integrity above all.
                                        </small>
                                    </p>
                                    <p className='mb-0'><b>About Mandaluyong City</b></p>
                                    <p>
                                        <small>
                                            Mandaluyong City is referred to as “Tiger City of the Philippines”, “Metro Manila’s Heart”, and the
                                            “Shopping Mall Capital of the Philippines”. It is well developed that many of its infrastructures
                                            are owned and managed by the most successful business men in the country.
                                        </small>
                                    </p>
                                </div>
                                <div className='col-lg-7'>
                                    <iframe className="embed-responsive-item"
                                        width="100%" height="400rem"
                                        src="https://maps.google.com/maps?q=St%20Francis%20Shangrila&t=&z=17&ie=UTF8&iwloc=&output=embed"
                                        frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default StFrancisShangrila